import { Injectable, inject } from '@angular/core';
import { notifApi, notifDtos } from '@vectronic/openApi-admin';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private adminNotifApi = inject(notifApi.Admin);

  addNotificationsToDevices(
    notifications: notifDtos.Notification[],
    deviceIds: number[],
  ): Observable<void> {
    const notificationsForAllDevices = notifications
      .map((notification) =>
        deviceIds.map((deviceId) => {
          const notif: notifDtos.Notification = JSON.parse(JSON.stringify(notification));
          notif.notificationRule.collarId = deviceId;
          return notif;
        }),
      )
      .reduce((acc, val) => acc.concat(val), []);
    return this.adminNotifApi.adminAddMultipleNotifications(notificationsForAllDevices);
  }

  static createNotificationRule(deviceId: number): notifDtos.NotificationRule {
    return {
      collarId: deviceId,
      activity: true,
      gpsPosition: true,
      gsmQuality: true,
      mortality: true,
      mortalityImplant: true,
      proximity: true,
      separation: true,
      trapEvent: true,
      vaginalImplant: true,
      virtualFence: true,
      command: true,
    };
  }
}
